<style>
.days-container {
  color: #495057;
}
</style>

<template>
  <b-modal
    ref="notificationsModal"
    header-class="anchor-modal"
    :title="item.title"
    hide-footer
    @hidden="$emit('hidden')"
  >
    <div class="days-container text-right">
      <small>{{item.days}}</small>
    </div>
    <div v-html="item.body"></div>
  </b-modal>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  methods: {
    show() {
      this.$refs.notificationsModal.show();
    },
    hide() {
      this.$refs.notificationsModal.hide();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/profile/notifications/NotificationModal.vue